module.exports = __webpack_public_path__ + "img/Kazakhstan.166a061d.svg";